import {createContext} from 'react';

export const SectionIdContext = createContext(null);
